const Maybe = ({ children, empty = null, test }) => <>{ test ? children : empty }</>

export default Maybe